function SectionHeader({ title, subtitle, rightContent = null, style = {} }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        gap: "16px",
        flexWrap: "wrap",
        marginBottom: "18px",
        ...style,
      }}
    >
      <div>
        <h2
          style={{
            margin: 0,
            fontSize: "28px",
            lineHeight: 1.15,
          }}
        >
          {title}
        </h2>

        {subtitle ? (
          <p
            style={{
              margin: "8px 0 0 0",
              color: "#cfcfcf",
              lineHeight: "1.7",
            }}
          >
            {subtitle}
          </p>
        ) : null}
      </div>

      {rightContent ? <div>{rightContent}</div> : null}
    </div>
  );
}

export default SectionHeader;
